/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "1",
    title: "Jane Eyre",
    author: "Charlotte Brontë",
    categoryName: "literature",
    price: "155",
    prevPrice: "259",
    discount: "40",
    rating: "4.4",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image: "https://m.media-amazon.com/images/I/91zU70Aw9IS.jpg",
  },
  {
    _id: "2",
    title: "Atomic habbits",
    author: "James Clear",
    categoryName: "self-help",
    price: "500",
    prevPrice: "799",
    discount: "36",
    rating: "4.6",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/51S7KOWir7L._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "3",
    title: "Educated: A Memoir",
    author: "Tara Westover",
    categoryName: "biography",
    price: "190",
    prevPrice: "249",
    discount: "24",
    rating: "4.5",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image: "https://m.media-amazon.com/images/I/41aG46Mm7ZL._SY346_.jpg",
  },
  {
    _id: "4",
    title: "Neuromancer",
    author: "William Gibson",
    categoryName: "science-fiction",
    price: "150",
    prevPrice: "199",
    discount: "25",
    rating: "4.3",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://toughguybookclub.com/storage/app/uploads/public/5ed/b5d/64b/5edb5d64b23ac080895835.jpg",
  },
  {
    _id: "5",
    title: "Dune",
    author: "Frank Herbert",
    categoryName: "science-fiction",
    price: "250",
    prevPrice: "299",
    discount: "16",
    rating: "4.7",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://kbimages1-a.akamaihd.net/3bf2e000-0418-4d89-ae3a-f9f3bbc92865/1200/1200/False/dune-the-graphic-novel-book-1-dune.jpg",
  },
  {
    _id: "6",
    title: "Attitude Is Everything",
    author: "Jeff Keller",
    categoryName: "self-help",
    price: "139",
    prevPrice: "199",
    discount: "30",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/710jnzKlDTL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "7",
    title: "1984",
    author: "George Orwell",
    categoryName: "science-fiction",
    price: "190",
    prevPrice: "299",
    discount: "36",
    rating: "4.6",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/book/j/p/v/1984-original-imaggp4yxhybn4zy.jpeg?q=70",
  },

  {
    _id: "8",
    title: "Pride and Prejudice",
    author: "Jane Austen",
    categoryName: "literature",
    price: "150",
    prevPrice: "249",
    discount: "40",
    rating: "4.8",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://rukminim1.flixcart.com/image/832/832/kkec4280/book/d/h/d/pride-prejudice-original-imafzra6pfewjjwb.jpeg?q=70",
  },
  {
    _id: "9",
    title: "One Arranged Marriage",
    author: "Chetan Bhagat",
    categoryName: "contemporary-fiction",
    price: "147",
    prevPrice: "225",
    discount: "35",
    rating: "4.4",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/71fgd+WAkHL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "10",
    title: "Gone Girl",
    author: "Gillian Flynn",
    categoryName: "psychological-thriller",
    price: "150",
    prevPrice: "199",
    discount: "25",
    rating: "4.3",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/book/9/k/v/gone-girl-original-imagjyquehzbmh4r.jpeg?q=70",
  },
  {
    _id: "11",
    title: "The Forgotten Kingdom",
    author: "Emily Roberts",
    categoryName: "Fantasy",
    price: "149.99",
    prevPrice: "179.99",
    discount: "17",
    rating: "3.4",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image: "https://m.media-amazon.com/images/I/81+dbC2IMrL.jpg",
  },
  {
    _id: "12",
    title: "Becoming",
    author: "Michelle Obama",
    categoryName: "biographies-autobiographies",
    price: "442",
    prevPrice: "699",
    discount: "37",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/91EhnA7oXHL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "13",
    title: "Can Love Happen Twice",
    author: "Ravinder Singh",
    categoryName: "contemporary-fiction",
    price: "133",
    prevPrice: "199",
    discount: "33",
    rating: "4.3",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/91xqVJ2ZkXL._AC_UY436_FMwebp_QL65_.jpg",
  },

  {
    _id: "14",
    title: "Chanakya Neeti",
    author: "Chanakya",
    categoryName: "spirituality",
    price: "126",
    prevPrice: "175",
    discount: "28",
    rating: "4.4",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81uqBB0yjVL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "15",
    title: "Foundation",
    author: "Isaac Asimov",
    categoryName: "science-fiction",
    price: "180",
    prevPrice: "249",
    discount: "28",
    rating: "4.7",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1417900846i/29579.jpg",
  },
  {
    _id: "16",
    title: "The Power Of Letting Go",
    author: "John Purkiss",
    categoryName: "self-help",
    price: "590",
    prevPrice: "650",
    discount: "0",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/61bKDUjhloL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "17",
    title: "Death",
    author: "Sadhguru",
    categoryName: "spirituality",
    price: "191",
    prevPrice: "299",
    discount: "36",
    rating: "4.7",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/91co3ZyqsML._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "18",
    title: "Deep Work",
    author: "Cal Newport",
    categoryName: "self-help",
    price: "325",
    prevPrice: "399",
    discount: "19",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/814IUt6WOKL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "19",
    title: "Girl In Room 105",
    author: "Chetan Bhagat",
    categoryName: "contemporary-fiction",
    price: "114",
    prevPrice: "199",
    discount: "43",
    rating: "4.4",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81l9tZKRZLL._AC_UY436_FMwebp_QL65_.jpg",
  },

  {
    _id: "20",
    title: "Half Girlfriend",
    author: "Chetan Bhagat",
    categoryName: "contemporary-fiction",
    price: "100",
    prevPrice: " 250",
    discount: "60",
    rating: "4.2",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/712HEn9SNwL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "21",
    title: "The Silent Patient",
    author: "Alex Michaelides",
    categoryName: "psychological-thriller",
    price: "170",
    prevPrice: "229",
    discount: "26",
    rating: "4.8",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://www.deccanherald.com/sites/dh/files/article_images/2020/05/19/file76dz10rjyo71a09bo1y2-1386543392-1569699001.jpg",
  },
  {
    _id: "22",
    title: "Ikigai",
    author: "Héctor García ",
    categoryName: "self-help",
    price: "295",
    prevPrice: "255",
    discount: "46",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UY436_FMwebp_QL65_.jpg",
  },

  {
    _id: "23",
    title: "Karma",
    author: "Sadhguru",
    categoryName: "spirituality",
    price: "148",
    prevPrice: "299",
    discount: "51",
    rating: "4.7",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/9167i2ioFaS._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "24",
    title: "Hyperion",
    author: "Dan Simmons",
    categoryName: "science-fiction",
    price: "190",
    prevPrice: "249",
    discount: "24",
    rating: "4.5",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image: "https://m.media-amazon.com/images/I/91XrTM0aCML.jpg",
  },
  {
    _id: "25",
    title: "The Great Gatsby",
    author: "F. Scott Fitzgerald",
    categoryName: "literature",
    price: "160",
    prevPrice: "269",
    discount: "40",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "http://cdn.shopify.com/s/files/1/2789/4914/products/book-prakash-books-9780143454212-35726547058883.jpg?v=1651934248",
  },
  {
    _id: "26",
    title: "Leaders Eat Last",
    author: "Simon Sinek",
    categoryName: "self-help",
    price: "386",
    prevPrice: "599",
    discount: "36",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/71rMrK1DdZL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "27",
    title: "Wuthering Heights",
    author: "Emily Brontë",
    categoryName: "literature",
    price: "150",
    prevPrice: "249",
    discount: "40",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://kbimages1-a.akamaihd.net/6a3aa32a-8481-4ff3-b21d-ec582dac192a/353/569/90/False/wuthering-heights-232.jpg",
  },
  {
    _id: "28",
    title: "Life's Amazing Secrets",
    author: "Gaur Gopal Das",
    categoryName: "spirituality",
    price: "215",
    prevPrice: "225",
    discount: " 4",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/81N7FmJhbhL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "29",
    title: "I Too Had A Love Story",
    author: "Ravinder Singh",
    categoryName: "contemporary-fiction",
    price: "191",
    prevPrice: "199",
    discount: " 4",
    rating: "4.4",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81fxf8EaTgL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "30",
    title: "Behind Closed Doors",
    author: "B.A. Paris",
    categoryName: "psychological-thriller",
    price: "170",
    prevPrice: "229",
    discount: "26",
    rating: "4.8",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/513xjPRWQGL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
  },
  {
    _id: "31",
    title: "Meluha",
    author: "Amish Tripathi",
    categoryName: "mythology",
    price: "302",
    prevPrice: "499",
    discount: "39",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/8181LdPn39L._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "32",
    title: "Nagas",
    author: "Amish Tripathi",
    categoryName: "mythology",
    price: "245",
    prevPrice: "450",
    discount: "46",
    rating: "4.6",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/91+4ShnL4TL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "33",
    title: "The Power Of Now",
    author: "Eckhart Tolle",
    categoryName: "spirituality",
    price: "340",
    prevPrice: "499",
    discount: "32",
    rating: "4.5",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81rTrhtGDvL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "34",
    title: "Psychology Of Money",
    author: "Morgan Housel",
    categoryName: "self-help",
    price: "267",
    prevPrice: "399",
    discount: "33",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/71g2ednj0JL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "35",
    title: "Ram",
    author: "Amish Tripathi",
    categoryName: "mythology",
    price: "272",
    prevPrice: "450",
    discount: "40",
    rating: "4.4",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81um1SFs6QL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "36",
    title: "Ravaan",
    author: "Amish Tripathi",
    categoryName: "mythology",
    price: "259",
    prevPrice: "499",
    discount: "48",
    rating: "4.6",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/812dmVf1V8S._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "37",
    title: "Brave New World",
    author: "Aldous Huxley",
    categoryName: "science-fiction",
    price: "190",
    prevPrice: "309",
    discount: "38",
    rating: "4.5",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://i2.wp.com/www.literaryretreat.com/wp-content/uploads/2018/02/Brave-New-World-Cover.jpg?w=670&ssl=1",
  },
  {
    _id: "38",
    title: "Rich Dad Poor Dad",
    author: "Robert T. Kiyosaki",
    categoryName: "self-help",
    price: "243",
    prevPrice: "499",
    discount: "51",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/81bsw6fnUiL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "39",
    title: "Secrets",
    author: "Rhonda Byrne",
    categoryName: "self-help",
    price: "477",
    prevPrice: "799",
    discount: "40",
    rating: "4.6",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/81fdQIY6ykL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "40",
    title: "Ender's Game",
    author: "Orson Scott Card",
    categoryName: "science-fiction",
    price: "170",
    prevPrice: "229",
    discount: "26",
    rating: "4.6",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1452898522l/8045789.jpg",
  },
  {
    _id: "41",
    title: "Sita",
    author: "Amish Tripathi",
    categoryName: "mythology",
    price: "350",
    prevPrice: "299",
    discount: "12",
    rating: "4.5",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/61HK5Tm1QyL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "42",
    title: "The Couple Next Door",
    author: "Shari Lapena",
    categoryName: "psychological-thriller",
    price: "150",
    prevPrice: "199",
    discount: "25",
    rating: "4.3",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image: "https://cdn2.penguin.com.au/covers/400/9780552173148.jpg",
  },
  {
    _id: "43",
    title: "The 5 AM Revolution",
    author: "Dan Luca",
    categoryName: "spirituality",
    price: "169",
    prevPrice: "295",
    discount: "43",
    rating: "4.3",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/611UKbv6bPL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "44",
    title: "Snow Crash",
    author: "Neal Stephenson",
    categoryName: "science-fiction",
    price: "150",
    prevPrice: "199",
    discount: "25",
    rating: "4.3",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image: "https://m.media-amazon.com/images/I/91NrsGzBjUL.jpg",
  },
  {
    _id: "45",
    title: "The Alchemist",
    author: "Paulo Coelho",
    categoryName: "spirituality",
    price: "229",
    prevPrice: "350",
    discount: "35",
    rating: "4.6",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/71aFt4+OTOL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "46",
    title: "The Bhagavadgita",
    author: "S. Radhakrishnan",
    categoryName: "spirituality",
    price: "293",
    prevPrice: "499",
    discount: "41",
    rating: "4.7",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/91DhR3OJboL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "47",
    title: "The Power Of Intuition",
    author: "Emma Lucy Knowles",
    categoryName: "spirituality",
    price: "473",
    prevPrice: "599",
    discount: "21",
    rating: "4.5",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/71iJbC57J3L._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "48",
    title: "The Subtle Art",
    author: "Mark Manson",
    categoryName: "self-help",
    price: "269",
    prevPrice: "499",
    discount: "46",
    rating: "4.5",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/814jC+rODgL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "49",
    title: "Think Like A Monk",
    author: "Jay Shetty",
    categoryName: "spirituality",
    price: "338",
    prevPrice: "499",
    discount: "32",
    rating: "4.6",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81s6DUyQCZL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "50",
    title: "The Breakdown",
    author: "B.A. Paris",
    categoryName: "psychological-thriller",
    price: "190",
    prevPrice: "249",
    discount: "24",
    rating: "4.5",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image:
      "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1492234495i/31450633.jpg",
  },
  {
    _id: "51",
    title: "Unfinished",
    author: "Priyanka Chopra Jonas",
    categoryName: "biographies-autobiographies",
    price: "352",
    prevPrice: "699",
    discount: "50",
    rating: "4.4",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/81tHdhbrGEL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "52",
    title: "Dark Places",
    author: "Gillian Flynn",
    categoryName: "psychological-thriller",
    price: "170",
    prevPrice: "229",
    discount: "26",
    rating: "4.8",
    bestseller: true,
    newRelease: false,
    expertPick: false,
    image: "https://covers.openlibrary.org/b/id/11567415-L.jpg",
  },
  {
    _id: "53",
    title: "Vayuputras",
    author: "Amish Tripathi",
    categoryName: "mythology",
    price: "403",
    prevPrice: "599",
    discount: "33",
    rating: "4.6",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/91gLF02WsHL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "54",
    title: "You Can Win",
    author: "Shiv Khera",
    categoryName: "self-help",
    price: "279",
    prevPrice: "399",
    discount: "30",
    rating: "3.8",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/81r9oQNPuNL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "55",
    title: "Think and Grow Rich",
    author: "Napoleon Hill",
    categoryName: "self-help",
    price: "100",
    prevPrice: "199",
    discount: "51",
    rating: "3.9",
    bestseller: false,
    newRelease: false,
    expertPick: true,
    image:
      "https://m.media-amazon.com/images/I/51qw-StAobL._AC_UY436_FMwebp_QL65_.jpg",
  },
  {
    _id: "56",
    title: "The Intelligent Investor",
    author: "Benjamin Graham ",
    categoryName: "self-help",
    price: "480",
    prevPrice: "799",
    discount: "40",
    rating: "4.5",
    bestseller: false,
    newRelease: true,
    expertPick: false,
    image:
      "https://m.media-amazon.com/images/I/91+t0Di07FL._AC_UY436_FMwebp_QL65_.jpg",
  },
];
